<script>
  export let idUnico = 'imagem';
  export let sub = false;
  export let hasLegenda = false;
  export let rounded = false;
  export let norounded = false;
  export let zoom = true;
  export let content;
  export let arquivoImagem = 'assets/images/imagem_1.jpg';
  export let titulo = '';
  import navegacaoStore from '../../store';
  import { onMount } from 'svelte';
  import { location } from 'svelte-spa-router';
  import IoIosClose from 'svelte-icons/io/IoIosClose.svelte';

  let ativo = false;
  let legenda = [];
  let tagBegin;
  let tagEnd;
  let root;
  let borderBegin;
  let borderEnd;
  let tamanhoBegin;
  let tamanhoEnd;

  function abrir() {
    ativo = true;
  }

  // console.log(content);

  tagBegin = content.indexOf('<legenda>');
  if (tagBegin != -1) {
    tagEnd = content.indexOf('</legenda>');
    if (tagEnd != -1) {
      legenda = content.substring(tagBegin + '<legenda>'.length, tagEnd);
      if (content.substring(tagBegin + '<legenda>'.length, tagEnd).trim() != '') {
        legenda = content.substring(tagBegin + '<legenda>'.length, tagEnd).split(';;');
        hasLegenda = true;
      }
    }
  }

  let imgId = [];
  imgId = idUnico.split('-');

  let indexDescricao;
  let descricao;
  let fonte;
  let imagens;
  let imagem;
  let i = 0;
  let placeholder = false;
  let dados;
  let url = Number($location.split('/')[1]) - 1;
  // let timestampTrick;
  let aux;

  aux = content.indexOf('{ROUNDED}');

  navegacaoStore.subscribe((dadosStore) => {
    dados = dadosStore;
  });

  let titleBegin;
  let titleEnd;
  let titleFrase = '';
  let quadro = false;

  onMount(() => {
    borderBegin = content.indexOf('{border}');
    if (borderBegin != -1) {
      borderEnd = content.indexOf('{/border}');
      if (borderEnd != -1) {
        root.style.setProperty(
          '--title-border-bottom',
          content.substring(borderBegin + '{border}'.length, borderEnd)
        );
        console.log('border: ' + content.substring(borderBegin + '{border}'.length, borderEnd));
      }
    }
    tamanhoBegin = content.indexOf('{tamanho}');
    if (tamanhoBegin != -1) {
      tamanhoEnd = content.indexOf('{/tamanho}');
      if (tamanhoEnd != -1) {
        root.style.setProperty(
          '--tamanho',
          content.substring(tamanhoBegin + '{tamanho}'.length, tamanhoEnd)
        );
        console.log('tamanho: ' + content.substring(tamanhoBegin + '{tamanho}'.length, tamanhoEnd));
      } else {
        root.style.setProperty('--tamanho', '100%');
      }
    } else {
      root.style.setProperty('--tamanho', '100%');
    }
    // timestampTrick = Date.now();
    titleBegin = content.indexOf('<titulo>');
    if (titleBegin != -1) {
      titleEnd = content.indexOf('</titulo>');
      if (titleEnd != -1) {
        titleFrase = content.substring(titleBegin + 8, titleEnd);
        content = content.substring(titleEnd + 9, content.length);
      }
    }
    titleBegin = content.indexOf('<tituloquadro>');
    if (titleBegin != -1) {
      titleEnd = content.indexOf('</tituloquadro>');
      if (titleEnd != -1) {
        titleFrase = content.substring(titleBegin + 14, titleEnd);
        content = content.substring(titleEnd + 15, content.length);
        quadro = true;
      }
    }

    let imagemId;
    let loaded = false;
    let type = ['.jpg', '.png', '.svg', '.webp'];

    arquivoImagem =
      dados.imagePath + imgId[0] + '_m' + dados.modulo + '_u' + imgId[1] + '_' + imgId[2] + type[0];

    imagemId = document.getElementById('imagem_u' + imgId[1] + '_' + imgId[2]);

    imagemId.onerror = function () {
      do {
        i++;
        arquivoImagem =
          dados.imagePath +
          imgId[0] +
          '_m' +
          dados.modulo +
          '_u' +
          imgId[1] +
          '_' +
          imgId[2] +
          type[i];
        loaded = true;
      } while (!loaded);
      if (i == type.length) {
        placeholder = true;
      }
    };

    let zoom_container = document.querySelector(
      '#container_u' + imgId[1] + '_' + imgId[2] + '.img-zoom-container'
    );

    let imgHeightPlaceholder = document.querySelector(
      '#imgHeightPlaceholder_u' + imgId[1] + '_' + imgId[2] + '.imagem'
    );
  });
</script>

<div class="container" bind:this={root}>
  <div class="img-title {titleFrase != '' ? '' : 'hide'} {quadro ? 'quadro' : ''}">
    {@html titleFrase}
  </div>
  <div
    class="imagem"
    id={'imgHeightPlaceholder_u' + imgId[1] + '_' + imgId[2]}
    class:rounded
    class:sub
    class:norounded
  >
    {#if !placeholder}
      <img
        class={aux != -1 ? ' round-bot' : ''}
        src={arquivoImagem}
        alt=""
        id={'imagem_u' + imgId[1] + '_' + imgId[2]}
      />
      {#if zoom}
        <div on:click={abrir} class="zoom">
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
      {/if}
      {#if dados.dev_mode == true}
        <div class="dev-mode-block">
          {'imagem_u' + imgId[1] + '_' + imgId[2]}
        </div>
      {/if}
    {:else}
      <div class="placeholder">
        <h2>{'imagem_u' + imgId[1] + '_' + imgId[2]}</h2>
      </div>
    {/if}
  </div>

  <div class="justify-content-center">
    {#if hasLegenda}
      <div class="legenda-wrapper">
        {@html legenda[0] ? legenda[0] : ''}
        {@html legenda[1] ? legenda[1] : ''}
        {@html legenda[2] ? legenda[2] : ''}
      </div>
    {/if}
  </div>
</div>

{#if zoom}
  <div class="dialog-img {ativo ? 'active' : ''}">
    <div class="wrapper-img">
      <div class="botao-fechar" on:click={() => (ativo = false)}>
        <IoIosClose />
      </div>
      <img
        class={aux != -1 ? ' round-bot' : ''}
        src={arquivoImagem}
        alt=""
        id={'imagem_u' + imgId[1] + '_' + imgId[2]}
      />
    </div>
    <div class="background {ativo ? 'active' : ''}" on:click={() => (ativo = false)} />
  </div>
{/if}

<style>
  :global(.img-title.hide) {
    display: none;
  }
  :global(.img-title) {
    background: var(--VERDE);
    color: white;
    padding: 10px 15px 9px 15px;
    text-align: center;
    border-radius: 12px 12px 0 0;
    font-family: var(--FONT_INTER);
    font-size: 18px;
    font-weight: 600;
    /* margin-bottom: 10px; */
    border-bottom: var(--title-border-bottom) solid var(--CINZA);
    position: relative;
    z-index: 101;
  }
  :global(.img-title.quadro) {
    margin-bottom: -5px;
    padding: 15px 15px;
    border-radius: 0;
    font-size: 19px;
    border-top: none;
  }
  .dialog-img {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 101;
    visibility: hidden;
    opacity: 0;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    transition: all 500ms ease;
    overflow-y: scroll;
  }
  .dialog-img.active {
    visibility: visible;
    opacity: 1;
    transition: all 500ms ease;
  }
  .background {
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    visibility: hidden;
    opacity: 0;
    position: fixed;
    height: 100vh;
    width: 100vw;
    max-width: 100%;
    z-index: 102;
    transition: all 300ms ease;
  }

  .background.active {
    visibility: visible;
    opacity: 1;
    transition: all 100ms ease;
    backdrop-filter: blur(3px);
  }

  .wrapper-img {
    position: relative;
    width: min(70%, 900px);
    max-height: 90vh;
    z-index: 103;
    overflow-y: auto;
  }

  .wrapper-img :global(img) {
    background: #fcfcfc;
    width: 100%;
  }

  .botao-fechar {
    width: 30px;
    cursor: pointer;
    color: var(--COR_FONTE);
    position: absolute;
    right: 10px;
    /* left: calc(50% + calc(min(70%, 900px) / 2) - 50px); */
    top: 10px;
    /* top: calc(50% - calc(45vh) + 10px); */
    opacity: 0.9;
    background: var(--COR_BRANCO);
    border-radius: 50%;
    z-index: 105;
    filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.5));
  }

  .botao-fechar:hover {
    opacity: 1;
  }
  .imagem {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    text-align: center;
    z-index: 100;
  }

  .imagem.rounded :global(img) {
    border-radius: 0 0 25px 25px;
  }

  .imagem.norounded :global(img) {
    border-radius: 0;
  }

  .imagem.sub {
    height: 200px;
    background: var(--COR_MODULO_SUPER_FRACO);
  }

  .imagem img {
    width: 100%;
    width: var(--tamanho);
  }

  h2 {
    margin-top: 0 !important;
    color: var(--COR_MOD_PRI);
    color: var(--COR_BRANCO);
    font-size: 16px;
    font-weight: 400;
    border: 1px solid white;
    border-radius: 4px;
    padding: 5px 10px;
    background: var(--COR_MOD_PRI);
  }

  .dev-mode-block {
    position: absolute;
    background: #4bd86311;
    font-size: 13px;
    padding: 2px 15px 2px 20px;
    border-radius: 10px;
    top: 0px;
    left: calc(100% - 10px);
    z-index: -1;
    border: 1px solid white;
    display: block;
    font-family: var(--FONT_INTER);
    color: #999;
  }

  .zoom {
    position: absolute;
    width: 50px;
    height: 50px;
    background: #555;
    background: var(--MARROM);
    right: -80px;
    /* bottom: 0; */
    z-index: 1;
    opacity: 0.8;
    border-radius: 10px;
    top: 50%;
    transform: translateY(-50%);
    /* filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.3)); */
  }

  .zoom i {
    font-size: 32px;
    color: var(--COR_BRANCO);
    padding: 9px 0;
  }

  .zoom:hover {
    opacity: 1;
    cursor: pointer;
  }

  .zoom::after {
    content: 'Clique na lupa para ampliar a imagem.';
    position: absolute;
    left: 100%;
    top: 0;
    font-family: var(--FONT_MERRI);
    font-size: 13px;
    width: 150px;
    filter: none;
    background: #c2885f11;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 5px;
    border-radius: 0 10px 10px 0;
  }

  .placeholder {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed var(--COR_MOD_PRI);
    background: var(--COR_MOD_QUI);
  }
  .placeholder h2 {
    font-family: var(--FONT_INTER);
  }
  .legenda-wrapper :global(div span) {
    font-style: normal;
    font-size: 15px;
  }
  .legenda-wrapper {
    --Gradientes-Degrad-principal: linear-gradient(to right, #33cfb9, #b62ca2);
    --Gradientes-Degrad-principal-inv: linear-gradient(
      to left,
      var(--VERDE_CLARO),
      var(--VERDE_LEGENDA)
    );
    --Principais-Texto: #000000;
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;
    --Infogrficos-Cinza: #e1e4e5;
    --Infogrficos-Cinza: #fff;
    color: var(--Principais-Verde-mdio, #559c92);
    color: var(--MARROM);
    text-align: right;
    font-family: var(--FONT_LORA);
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    border-radius: 0 0 30px 0px;
    padding: 15px 20px 15px 10px;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    background-image: linear-gradient(var(--Infogrficos-Cinza), var(--Infogrficos-Cinza)),
      var(--Gradientes-Degrad-principal-inv);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    line-height: normal;
    text-wrap-style: pretty;
    position: relative;
    z-index: 2;
  }
  .legenda-wrapper:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, white, #f2f2f2, white),
      linear-gradient(to bottom, #f2f2f2, white);
    /* background: white; */
    z-index: -1;
    border-radius: 0 0 32px 0;
  }

  .legenda-wrapper :global(div:nth-child(1)) {
    font-size: 16px;
    color: var(--VERDE_LEGENDA);
  }

  @media (max-width: 767px) {
    .imagem :global(img) {
      width: 100%;
    }

    .zoom {
      display: none;
    }

    .dialog-img {
      display: none;
    }
  }
</style>
